import React from 'react';

import { IonItem, IonList, IonSkeletonText } from '@ionic/react';

import Typography from 'components/Typography';
import Avatar from 'scenes/FinancePage/components/Avatar';

import './index.css';

const ListSkeleton = () => {
  return (
    <>
      <div className={'finance-list-skeleton'}>
        <IonList lines={'full'}>
          {new Array(15).fill(null).map((_: any, index: number) => (
            <IonItem key={index}>
              <Avatar slot={'start'}>
                <IonSkeletonText animated />
              </Avatar>
              <div>
                <Typography variant={'overline'}>
                  <IonSkeletonText animated />
                </Typography>
                <Typography variant={'subtitle1'}>
                  <IonSkeletonText animated />
                </Typography>
                <Typography>
                  <IonSkeletonText animated />
                </Typography>
              </div>
            </IonItem>
          ))}
        </IonList>
      </div>
    </>
  );
};
export default ListSkeleton;
